import {Validation} from "@/data/Validation";

export type OrderPlacementDeliveryAddress =
    | OrderPlacementTakeawayDeliveryAddress
    | OrderPlacementExistingDeliveryAddress
    | OrderPlacementBusinessDeliveryAddress
    | OrderPlacementNewDeliveryAddress;

export type OrderPlacementTakeawayDeliveryAddress = {
    type: "TAKEAWAY";
};

export type OrderPlacementExistingDeliveryAddress = {
    type: "EXISTING";
    id: number,
};

export type OrderPlacementBusinessDeliveryAddress = {
    type: "BUSINESS";
};

export type OrderPlacementNewDeliveryAddress = {
    type: "NEW";
    address: {
        name: string | null,
        street: string,
        streetNumber: string,
        postalCodeDigits: string,
        postalCodeLetters: string,
        city: string,
        extraAddressInfo: string | null,
    },
};

export type OrderPlacementAddress = OrderPlacementNewDeliveryAddress["address"];

export const emptyNewDeliveryAddress = (): OrderPlacementNewDeliveryAddress => ({
    type: "NEW",
    address: {
        name: null,
        street: "",
        streetNumber: "",
        postalCodeDigits: "",
        postalCodeLetters: "",
        city: "",
        extraAddressInfo: null,
    },
});

export const POSTAL_CODE_DIGITS_PATTERN = /^\d{4}$/;

export const POSTAL_CODE_LETTERS_PATTERN = /^[a-zA-Z]{2}$/;

export const addressValidation: Validation<OrderPlacementAddress> = {
    name: {required: false, minLength: 1, maxLength: 50},
    street: {required: true, minLength: 1, maxLength: 100},
    streetNumber: {required: true, minLength: 1, maxLength: 20},
    postalCodeDigits: {required: true, minLength: 4, maxLength: 4},
    postalCodeLetters: {required: true, minLength: 2, maxLength: 2},
    city: {required: true, minLength: 1, maxLength: 100},
    extraAddressInfo: {required: false, minLength: 1, maxLength: 512},
};

/** "Steenstraat 12, 6800 AB Arnhem" */
export const formatAddress = (address: {
    street: string | null,
    streetNumber: string | null,
    postalCodeDigits: string | null,
    postalCodeLetters: string | null,
    city: string | null,
}): string => [
    `${address.street ?? ""} ${address.streetNumber ?? ""}`.trim(),
    `${address.postalCodeDigits ?? ""} ${address.postalCodeLetters ?? ""} ${address.city ?? ""}`.replace(/\s+/g, " ").trim(),
].filter(line => line.length > 0).join(", ");
